import $ from "cash-dom";
import setTimeoutAsync from "@common/utils/set-timeout";
import gaSC, { pbGA, pbGA2, npga2 } from "@common/utils/ga";
import { grabOnInit } from "@core";
import EmblaIntialization from "@common/carousel/embla-initialization";
import isMobile from "@common/utils/is-mobile";
import {
    shareFacebook, 
    shareLinkedIn, 
    shareEmail, 
    shareTwitter,
    shareWhatsApp,
    shareInstagram,
    copyUrlToClipboard
} from "@common/utils/sharers";


$(function onReady() {
    grabOnInit();
    
    // Footer Blogs Embla Setup

    const footerEmblaEle = document.getElementById('sulg-blog-embla');
    if(footerEmblaEle && footerEmblaEle !== null){
        const allEmblaSlides = footerEmblaEle.querySelectorAll('.embla__slide');
        const hasSlides = allEmblaSlides.length > 0;
        if(hasSlides){
            EmblaIntialization({
                rootNode: footerEmblaEle,
                disable: true,
                options:{
                    containScroll:isMobile() ? false : "trimSnaps",
                    align: isMobile() ? "center" : 'start',
                    
                    // containScroll:"trimSnaps",
                    // align: 'start',
                },
                navigation: {
                    show: true,
                    prevNode: footerEmblaEle.parentElement.querySelector('.embla__prev'),
                    nextNode: footerEmblaEle.parentElement.querySelector('.embla__next'),
                    disable:true
                },
                // @ts-ignore
                pagination:{
                    show: true,
                    dotsNode: footerEmblaEle.parentElement.querySelector(".embla__dots")
                },
            })
        }
        else{
            
            footerEmblaEle.parentElement.setAttribute('data-has-child', `${hasSlides}`);
        }
    }

    // function copyUrlToClipboard() {
    //     // Copy the current page's URL to the clipboard
    //     navigator.clipboard.writeText(window.location.href)
    //         .then(() => {
    //             // Success message (optional)
    //             console.log('URL copied to clipboard:', window.location.href);
    //         })
    //         .catch((error) => {
    //             // Error handling
    //             console.error('Failed to copy URL:', error);
    //         });
    // }


    // Share Functionality

    const allShareItems = $('div[data-type="social-icons"] > span');
    const shareTypes = {
        Facebook: {
            fun: shareFacebook,
            shareText: 'Share Text'
        },
        LinkedIn: {
            fun: shareLinkedIn,
            shareText: 'Share Text'
        },
        Instagram : {
            fun: shareInstagram,
            shareText: 'Share Text'
        },
        WhatsApp: {
            fun : shareWhatsApp,
            shareText: 'Share Text'
        },
        Twitter : {
            fun : shareTwitter,
            shareText: 'Share Text'
        }
    }
    allShareItems.each((i, ele)=>{
        const item = $(ele);
        item.on('click', function(){
            const dataType =item.attr('data-value')
            const shareURL = window.location.href;
            if(dataType !== 'Copy Link'){
                shareTypes[dataType].fun(shareURL, shareTypes[dataType].shareText);
            }
            else{
                copyUrlToClipboard();
            }
        })
    })

})